import { render, staticRenderFns } from "./BaseDate.vue?vue&type=template&id=347b3668&scoped=true&lang=pug&"
import script from "./BaseDate.vue?vue&type=script&lang=js&"
export * from "./BaseDate.vue?vue&type=script&lang=js&"
import style0 from "./BaseDate.vue?vue&type=style&index=0&id=347b3668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347b3668",
  null
  
)

export default component.exports